export default __webpack_public_path__ + "media/images/icons/portfolio-outline-c9d041b274c2ee1cd03e730c5c64a230.svg";